import { Component } from '@angular/core';

@Component({
  selector: 'app-gradient-bg',
  standalone: true,
  imports: [],
  templateUrl: './gradient-bg.component.html',
  styleUrl: './gradient-bg.component.scss'
})
export class GradientBgComponent {

}
